// extracted by mini-css-extract-plugin
export default {"root":"SignUpFormUserRequest_root__KLsyw","inputLink":"SignUpFormUserRequest_inputLink__Tfi3l","after":"SignUpFormUserRequest_after__US8OJ"};